import { ROUTES_CONFIG } from "./routes.config"

export const INSIGHTS_CONFIG = {
    fromPathLabels: {
        [ROUTES_CONFIG.integrationsUrl]: "Integrations",
        [ROUTES_CONFIG.reportsUrl]: "Reports",
    } as Record<string, string>,

    // Metabase centers "fixed width" dashboard content in a 1048px column with
    // 24px of side padding. Page copy matches that box so it lines up with the
    // embedded dashboard at any window width.
    embedContainerMaxWidthPx: 1048 + 24 * 2,

    demoNotice:
        "Insights shows you how Nirvana is performing for your practice, with reporting on prediction accuracy, denial trends, cost share breakdowns, and more. This feature isn't included in the demo - you'll see it with your live data.",
}
